import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';
import Search from '@mui/icons-material/Search';
import { useResponsive } from 'src/hooks/useResponsive';

const PREFIX = 'MenuSearchButton';

const classes = {
    icon: `${PREFIX}icon`
};

const StyledBox = styled(Box)(({ theme }) => ({
    [`& .${classes.icon}`]: {
        color: theme.palette.primary.contrastText,
        '& svg': {
            fontSize: theme.spacing(5)
        }
    }
}));

interface IMenuSearchButton {
    handleOpenMenuSearch: () => void;
}

export const MenuSearchButton: React.FC<React.PropsWithChildren<IMenuSearchButton>> = ({
    handleOpenMenuSearch
}) => {
    const { isDesktop } = useResponsive();

    if (isDesktop) {
        return null;
    }

    return (
        <StyledBox>
            <IconButton className={classes.icon} onClick={handleOpenMenuSearch} size="large">
                <Search />
            </IconButton>
        </StyledBox>
    );
};
